import { useState } from "react";
import { Button, Container, Grid, TextField, Typography } from "@mui/material";
import CustomBreadcrumbs from "../../../../components/breadcrumbs";
import SectionTitle from "../../../../components/sectionTitle";
import { createAttribute } from "../../../../controllers/company/products/AttributesController";
import QUDProgress from "../../../../components/progress";
import ResponseComponent from "../../../../components/responseComponent";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function AttributesCreate()
{
    const [name,setName] = useState('');
    const [errorName,setErrorName] = useState(false);

    const [isLoading,setIsLoading] = useState(false);

    const [open,setOpen] = useState(false);
    const [title,setTitle] = useState('');
    const [message,setMessage] = useState('');
    const [success,setSuccess] = useState(false);

    const history = useHistory();
    

    const formVerification = () => {
        let ban = 0;

        if(name === '')
        {
            setErrorName(true);
            ban = 1;
        }

        return ban;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if(formVerification()===0)
        {
            setIsLoading(true);
            const response = await createAttribute(name);
            if(response.success === true)
            {
                setTitle('Operación Exitosa');
                setMessage(response.message);
                setSuccess(true);
                setOpen(true);
            }
            else
            {
                setTitle('Operación Fallida');
                setMessage(response.message);
                setSuccess(false);
                setOpen(true);
            }

            setIsLoading(false);
        }
    }

    const handleClose = () => {
        setOpen(false);
        if(success === true)
        {
            history.push('/products/attributes');
        }
    }

    return(
        <Container maxWidth='xl'>
            <CustomBreadcrumbs returnTo='/products/attributes' crumbs={[{name:'Productos',link:'/products'},{name:'Atributos',link:'/products/attributes'},{name:'Crear',link:'/products/attributes/create'}]}/>
            <br/>
            <SectionTitle title='Crear Atributo' subtitle={'(Productos)'} />

            <Grid container spacing={3} justifyContent={'center'}>
                <Grid item lg={4} xl={4}>
                    <TextField
                        label='Nombre'
                        fullWidth
                        value={name}
                        onChange={(e)=>setName(e.target.value)}
                        onBlur={()=>setErrorName(name==='')}
                        error={errorName}
                        helperText={errorName?<Typography>El nombre es obligatorio</Typography>:''}
                    />
                    <Typography style={{fontSize: 16, color: 'gray', marginTop: 4}}>
                        Define una característica general que diferencia tus productos. Ejemplos: Tamaño, Color, Sabor, Material.
                    </Typography>
                    <Button
                        fullWidth
                        variant="contained"
                        sx={{mt:2}}
                        onClick={(e)=>handleSubmit(e)}
                    >
                        <Typography>Crear Atributo</Typography>
                    </Button>
                </Grid>
            </Grid>

            <QUDProgress open={isLoading}/>
            <ResponseComponent
                show={open}
                success={success}
                title={title}
                message={message}
                actionText={'Finalizar'}
                onClick={()=>handleClose()}
            />
        </Container>
    )
}